// Get the link element
var linkElement = document.querySelector('.menu-drawer__menu-item-cart');

// Add a click event listener to the link
linkElement.addEventListener('click', function(event) {
  event.preventDefault(); // Prevent the default link behavior
  
  // Find the element with the class .menu-opening and remove the class
  var menuOpeningElement = document.querySelector('.menu-opening');
  if (menuOpeningElement) {
    menuOpeningElement.classList.remove('menu-opening');
  }

    // Find and remove the "open" attribute from a div element
  var divWithOpenAttribute = document.querySelector('details[open]');
  if (divWithOpenAttribute) {
    divWithOpenAttribute.removeAttribute('open');
  }
  
  // Toggle a class on the header icon element to hide the pseudo-element
  var headerIconMenuElement = document.querySelector('.header__icon--menu[aria-expanded="true"]');
  if (headerIconMenuElement) {
    headerIconMenuElement.classList.add('hidden-pseudo');
  }
});

